(() => {
  const root = document.documentElement;
  const emailForms = new Set();
  const storage = {
    get(key) { try { return sessionStorage.getItem(key); } catch (_) { return null; } },
    set(key, value) { try { sessionStorage.setItem(key, value); } catch (_) {} }
  };
  let frame = 0, reopenTimer = null;
  let rewardsWasOpen = false, rewardsTrigger = null;
  let emailTrigger = null, lastOutsideFocus = document.activeElement;
  let emailFormId = storage.get('ssp-email-form');
  let automaticOfferShown = storage.get('ssp-email-offer-shown') === 'true';
  let pendingForm = null, requestedByUser = false, replaying = false;
  let suppressAutomatic = false, emailDismissRequested = false;
  const visible = element => {
    if (!element || element.hidden) return false;
    const style = getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden' && element.getClientRects().length > 0;
  };
  const emailDialog = () => Array.from(document.querySelectorAll('[role="dialog"][aria-modal="true"]')).find(element =>
    element.querySelector('input[type="email"]') && element.querySelector('button[aria-label="Close dialog"]')
  );
  function states(promo = emailDialog()) {
    const consent = visible(document.getElementById('m-cookie-banner'));
    const dialog = Array.from(document.querySelectorAll('dialog[open], [role="dialog"][aria-modal="true"], .ssp-popup.is-visible')).some(element => element !== promo && visible(element));
    const drawer = Array.from(document.querySelectorAll('.scd__wrapper')).some(visible);
    const menu = !!document.querySelector('.desktop-navigation details[open]');
    const rewards = !!document.querySelector('#smile-ui-container .smile-panel-frame-container');
    return {shopping: consent || dialog || drawer || menu, rewards};
  }
  function openEmail(id, manual) {
    if (!id) return;
    requestedByUser = manual;
    replaying = !manual;
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', id]);
  }
  function update() {
    frame = 0;
    const slot = document.getElementById('ssp-rewards-slot');
    const smile = document.getElementById('smile-ui-container');
    const utilities = document.getElementById('ssp-utility-controls');
    const top = document.getElementById('scroll-to-top-button');
    const offer = document.getElementById('ssp-email-offers');
    if (slot && smile && smile.parentElement !== slot) slot.append(smile);
    if (utilities && top && top.parentElement !== utilities) utilities.append(top);
    if (offer && offer.hidden === !!emailFormId) offer.hidden = !emailFormId;
    const promo = emailDialog();
    const state = states(promo);
    if (promo && visible(promo) && emailForms.size) {
      if (state.shopping || state.rewards || suppressAutomatic) {
        if (!emailDismissRequested) {
          if (!suppressAutomatic && !automaticOfferShown) pendingForm = emailFormId;
          emailDismissRequested = true;
          promo.querySelector('button[aria-label="Close dialog"]').click();
        }
      } else if (!automaticOfferShown) {
        automaticOfferShown = true;
        storage.set('ssp-email-offer-shown', 'true');
      }
    }
    const blocked = state.shopping || emailForms.size > 0;
    root.classList.toggle('ssp-shopping-overlay', blocked);
    root.classList.toggle('ssp-rewards-open', state.rewards);
    if (smile && smile.inert !== blocked) smile.inert = blocked;
    if (top && top.inert !== (blocked || state.rewards)) top.inert = blocked || state.rewards;
    if (offer && offer.inert !== (blocked || state.rewards)) offer.inert = blocked || state.rewards;
    if (state.rewards && !rewardsWasOpen) rewardsTrigger = document.activeElement;
    if (!state.rewards && rewardsWasOpen && !blocked && rewardsTrigger?.isConnected) rewardsTrigger.focus({preventScroll: true});
    rewardsWasOpen = state.rewards;
    if (pendingForm && !state.shopping && !state.rewards && !emailForms.size && !visible(promo)) {
      if (!reopenTimer) reopenTimer = setTimeout(() => {
        reopenTimer = null;
        const current = states();
        if (current.shopping || current.rewards || emailForms.size) return;
        const id = pendingForm;
        pendingForm = null;
        openEmail(id, false);
      }, 1500);
    } else if (reopenTimer) {
      clearTimeout(reopenTimer);
      reopenTimer = null;
    }
  }
  function schedule() { if (!frame) frame = requestAnimationFrame(update); }
  new MutationObserver(schedule).observe(document.body, {childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style', 'open', 'hidden', 'aria-modal']});
  document.addEventListener('toggle', schedule, true);
  document.addEventListener('close', schedule, true);
  document.addEventListener('shopify:section:load', schedule);
  window.addEventListener('resize', schedule, {passive: true});
  document.addEventListener('focusin', event => {
    if (!event.target.closest('[role="dialog"][aria-modal="true"]')) lastOutsideFocus = event.target;
  });
  document.addEventListener('click', event => {
    if (!event.target.closest('#ssp-email-offers')) return;
    emailTrigger = event.target.closest('#ssp-email-offers');
    pendingForm = null;
    openEmail(emailFormId, true);
  });
  window.addEventListener('klaviyoForms', event => {
    const detail = event.detail;
    if (!detail?.formId) return;
    if (detail.type === 'open') {
      emailFormId = String(detail.formId);
      storage.set('ssp-email-form', emailFormId);
      emailTrigger = requestedByUser ? emailTrigger : lastOutsideFocus;
      suppressAutomatic = automaticOfferShown && !requestedByUser && !replaying;
      requestedByUser = false;
      replaying = false;
      emailDismissRequested = false;
      emailForms.add(detail.formId);
    }
    if (detail.type === 'close' || detail.type === 'redirectedToUrl') {
      emailForms.delete(detail.formId);
      emailDismissRequested = false;
      suppressAutomatic = false;
      if (detail.type === 'close' && !pendingForm) setTimeout(() => {
        const current = states();
        if (current.shopping || current.rewards || emailForms.size) return;
        const target = emailTrigger?.isConnected && emailTrigger !== document.body ? emailTrigger : document.querySelector('header a');
        target?.focus({preventScroll: true});
      }, 0);
    }
    schedule();
  });
  update();
})();
